import React, {  useContext } from "react";

import PopupWinner from "../../components/Home/PopupWinner/PopupWinner";
import PopupWelcome from "../../components/Home/PopupWelcome/PopupWelcome";

import useSetPageTitle from "../../hooks/useSetPageTitle";
import UserContext from "../../contexts/UserContext";

import './styles.css';

import hello from '../../assets/images/toby-hello.png';
import PromoHome from "promos/PromoHome";

function Home() {
    const { currentPromo, currentUser } = useContext(UserContext);

    useSetPageTitle('Home', currentPromo);

    return(
        <div className="container-fluid">
            <div className="home-greet-container">
                <p className="home-greet">Olá, {currentUser?.nome ?? 'Visitante'}</p>
                <img className="greet-toby" src={hello} alt="hello" />
            </div>
            <PopupWinner />
            <PopupWelcome />
            <PromoHome />
        </div>
    )
}

export default Home;